var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKemi = function SvgKemi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.84 1h-.003.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004586",
    d: "m19.17 23.223-6.64-10.944V4.665a1.38 1.38 0 0 0-.168-2.748H8.064a1.38 1.38 0 0 0-.168 2.748v7.614l-6.64 10.943c-.579.955-.147 1.728.966 1.728h15.981c1.111 0 1.544-.773.965-1.727Z",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#004586",
    strokeLinecap: "square",
    d: "m9.5 15.5-4 6",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export { SvgKemi as ReactComponent };
export default __webpack_public_path__ + "740aa7def95fa91cb61d50fe6428b028.svg";